import { RuleSet } from './engine';

// Empty ruleset to use when API hasn't returned data yet
export const EMPTY_RULESET: RuleSet = {
  allow: [],
  deny: [],
};

// Helper function to get ruleset
export function getEmptyRuleset(): RuleSet {
  EMPTY_RULESET.allow = ['org:*::dash:*/widget:*::*'];
  return { ...EMPTY_RULESET };
}
